import request from '@onefootprint/request';
import type { AuthHeaders } from '@/hooks/use-session';

type RunWorkflowParams = {
  id: string;
  clearNodeIds?: string[];
  advanceStuckIncodeSession?: boolean;
};

const runWorkflow = async (authHeaders: AuthHeaders, params: RunWorkflowParams) => {
  const response = await request<Record<string, never>>({
    method: 'POST',
    url: '/private/protected/run_workflow',
    headers: authHeaders,
    data: {
      id: params.id,
      clear_node_ids: params.clearNodeIds ?? [],
      advance_stuck_incode_session: params.advanceStuckIncodeSession,
    },
  });
  return response.data;
};

export default runWorkflow;
